import * as types from '../types';
import { commonResponse } from '../../../utils';

const actionSucceeded = data => {
  return {
    type: types.FETCH_USER_SUCCEEDED,
    payload: data
  };
};

const actionFailed = error => {
  return {
    type: types.FETCH_USER_FAILED,
    payload: error
  };
};

export const fetchUser = userId => async (
  dispatch,
  getState,
  { PolicyHolderAPI }
) => {
  dispatch({ type: types.REQUEST_USER_DATA });
  let response = {};

  try {
    response = await PolicyHolderAPI.fetchUser(userId);
  } catch (error) {
    response.error = error && error.response && error.response.status;
  }

  response = commonResponse(response, response.error);

  const result = {
    true: actionSucceeded(response.data),
    false: actionFailed(response.error)
  };

  dispatch(result[response.success]);
};
